import axios from "axios";

export const fetchGanttData = async (companyCode, endDate) => {
    let url = "api/gantt/getGanttData/" + companyCode 
    if(endDate !== null) {
        url += "/?endDate=" + endDate;
    }
    const response = await axios.get(url);
    const ganttData = response.data;
    return ganttData;
}